/**
 * @generated SignedSource<<e24aec56223c8abe833fd6cd7e6854a7>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type AssetStatus = "AVAILABLE" | "IN_USE" | "LOST" | "MAINTENANCE" | "RETIRED" | "%future added value";
export type UpdateAssetInput = {
  assetId: string;
  clientMutationId?: string | null | undefined;
  dailyRate?: number | null | undefined;
  description?: string | null | undefined;
  make?: string | null | undefined;
  model?: string | null | undefined;
  notes?: string | null | undefined;
  ownerId?: string | null | undefined;
  parentAssetTag?: any | null | undefined;
  properties?: ReadonlyArray<PropertyInput> | null | undefined;
  rentable?: boolean | null | undefined;
  replacementValue?: number | null | undefined;
  serial?: string | null | undefined;
  status?: AssetStatus | null | undefined;
};
export type PropertyInput = {
  key: string;
  value: string;
};
export type OpsAssetPageUpdateMutation$variables = {
  input: UpdateAssetInput;
};
export type OpsAssetPageUpdateMutation$data = {
  readonly updateAsset: {
    readonly asset: {
      readonly id: string;
    } | null | undefined;
    readonly userErrors: ReadonlyArray<{
      readonly message: string;
    }>;
  } | null | undefined;
};
export type OpsAssetPageUpdateMutation = {
  response: OpsAssetPageUpdateMutation$data;
  variables: OpsAssetPageUpdateMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "UpdateAssetPayload",
    "kind": "LinkedField",
    "name": "updateAsset",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Asset",
        "kind": "LinkedField",
        "name": "asset",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "UserError",
        "kind": "LinkedField",
        "name": "userErrors",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "message",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "OpsAssetPageUpdateMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "OpsAssetPageUpdateMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "c9541c12598acd84c33b3bf6f9f035d2",
    "id": null,
    "metadata": {},
    "name": "OpsAssetPageUpdateMutation",
    "operationKind": "mutation",
    "text": "mutation OpsAssetPageUpdateMutation(\n  $input: UpdateAssetInput!\n) {\n  updateAsset(input: $input) {\n    asset {\n      id\n    }\n    userErrors {\n      message\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "efb01fc8f768912cad26af909126ce15";

export default node;
